import { Badge } from "./Badge";

const TONES: Record<string, "info" | "success" | "warning" | "danger" | "neutral"> = {
  // Orders
  draft: "neutral", pending_payment: "warning",
  payment_verification_pending: "warning",
  completed: "success", rejected: "danger", cancelled: "neutral",
  // Payment decisions
  pending: "warning", approved: "success",
  resubmission_requested: "warning",
  // Entries
  created: "info", placed: "info", processing: "warning",
  archived: "neutral", inactive: "neutral", blocked: "danger",
  // Stages
  locked: "neutral", active: "info",
  // Withdrawals
  requested: "warning", paid: "success",
  // Notifications
  queued: "warning", sending: "info", delivered: "success",
  failed: "danger", dead_letter: "danger",

  // 🛠️ NEW: Shipping Statuses
  shipped: "info", returned: "danger",
};

export function StatusPill({ status }: { status: string }) {
  const tone = TONES[status] ?? "neutral";
  const label = status.replace(/_/g, " ");
  return <Badge tone={tone} className="capitalize">{label}</Badge>;
}
